/** Rank glyphs indexed by rank (0=2 .. 12=A). */
export const RANK_CHARS = '23456789TJQKA';
/** Suit glyphs indexed by suit (0=c,1=d,2=h,3=s). Display form for template lines. */
export const SUIT_GLYPHS = ['♣', '♦', '♥', '♠']; // ♣ ♦ ♥ ♠
/** CardIndex → display string, e.g. 51 → "A♠". Cheap range check; formatting only, never crosses to
 *  the coach digest. */
export function formatCard(c) {
    const n = c;
    if (!Number.isInteger(n) || n < 0 || n > 51)
        throw new RangeError(`CardIndex out of range: ${n}`);
    return RANK_CHARS[n >> 2] + SUIT_GLYPHS[n & 3];
}
/** CardIndex[] → space-joined display, e.g. "A♠ K♥ 7♦". */
export function formatCards(cards) {
    return cards.map(formatCard).join(' ');
}
/** Whole-dollar display of a chip amount ("$29"). Chips are integers; templates round for display. */
export function money(amount) {
    return `$${Math.round(amount)}`;
}
/** How each sizing intent reads in prose (schema/action.ts SizingIntent). */
export const SIZING_PHRASE = {
    min: 'a min-bet',
    third: 'a third-pot bet',
    half: 'a half-pot bet',
    twoThirds: 'a two-thirds-pot bet',
    threeQuarters: 'a three-quarters-pot bet',
    pot: 'a pot-sized bet',
    overbet: 'an overbet',
    jam: 'all-in',
};
/** How each action reads in prose, optionally with its sizing intent. No dollars - the price/arithmetic
 *  templates own the numbers; this is the verb form for recommendation/rule lines. */
export function actionPhrase(action, sizingIntent) {
    switch (action) {
        case 'fold':
            return 'fold';
        case 'check':
            return 'check';
        case 'call':
            return 'call';
        case 'jam':
            return 'jam all-in';
        case 'bet':
            return sizingIntent ? `bet ${SIZING_PHRASE[sizingIntent].replace(/^a(n)? /, '')}` : 'bet';
        case 'raise':
            return sizingIntent ? `raise ${SIZING_PHRASE[sizingIntent].replace(/^a(n)? /, '')}` : 'raise';
    }
}
/** Prose for a classified board card event (schema/hand-class.ts BoardEventKind). */
export const BOARD_EVENT_PHRASE = {
    blank: 'a blank',
    overcard: 'an overcard',
    undercard: 'an undercard',
    pairs_board: 'pairs the board',
    flush_card: 'a flush card',
    completes_flush: 'completes a possible flush',
    straight_card: 'a straight card',
    completes_straight: 'completes a possible straight',
    two_tone: 'brings a second suit',
};
/** Board-event tone: draw-completing / scare cards read as caution, blanks as good, else neutral. */
export function boardEventTone(ev) {
    if (ev.completesFlush || ev.kind === 'completes_flush' || ev.kind === 'completes_straight')
        return 'caution';
    if (ev.kind === 'overcard' || ev.kind === 'flush_card' || ev.kind === 'straight_card')
        return 'caution';
    if (ev.kind === 'blank')
        return 'good';
    return 'neutral';
}
/** Grade-band ordering (0=worst punt .. 5=best excellent) + the shared tone mapping used by the
 *  arithmetic and debrief templates. Single source of truth so bands paint consistently. */
export const GRADE_BAND_RANK = {
    punt: 0,
    bad: 1,
    marginal: 2,
    acceptable: 3,
    good: 4,
    excellent: 5,
};
export function gradeBandTone(band) {
    if (band === 'excellent' || band === 'good')
        return 'good';
    if (band === 'acceptable')
        return 'neutral';
    if (band === 'marginal')
        return 'caution';
    return 'bad';
}
//# sourceMappingURL=cards.js.map